import Introduction from './components/Introduction-Section/Introduction';
import TimeLine from './components/TimeLine/TimeLine';
const Home = () => {
    return <>
        <Introduction />
        <TimeLine />
    </>
}

export default Home;